// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.playerGridContainer {
    width: 100%;
    padding: 20px;
    text-align: center;
    color: #fff;
    max-width: 500px;
  }
  
  .playerGridContainer p {
    margin-bottom: 20px;
    font-family: Lato;
    font-size: 16px;
    font-weight: 700;
  }
  
  .playerGrid {
    display: grid;
    grid-template-columns: repeat(2, 1fr); /* Définit 2 colonnes de taille égale */
    gap: 20px; /* Espacement entre les éléments de la grille */
    justify-content: center;
    align-items: center;
  }
  
  .playerGrid > *:nth-child(2n + 1):last-child {
    grid-column: span 2; /* Fait en sorte que le dernier élément s'étende sur 2 colonnes */
    justify-self: center; /* Centre l'élément dans la grille */
  }
  
  .playerCard {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: 160px;
    border-radius: 10px;
    padding: 8px;
    cursor: pointer;
  }
  
  .playerCard img {
    height: 80px;
    object-fit: contain;
    margin-bottom: 10px;
  }

  .playerCard svg{
    margin: 15px;
    height: 50px;
  }
  
  .playerCard .playerName {
    font-size: 16px;
    font-weight: 700;
    margin-bottom: 5px;
    margin-top: 8px;
  }
  
  .playerCard .playerNumber {
    position: absolute;
    top: 32px;
    font-size: 24px;
    font-weight: 700;
    color: #C3D32C;
    text-shadow: 1px 1px black;
  }
  
  .addIcon {
    color: #C3D32C;
    margin-bottom: 10px;
  }
  
  .shirtNumber{
    display: flex;
    justify-content: center;
    position: relative;
    height: 80px;
  }`, "",{"version":3,"sources":["webpack://./src/components/MonEquipe/PlayerGrid.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,aAAa;IACb,kBAAkB;IAClB,WAAW;IACX,gBAAgB;EAClB;;EAEA;IACE,mBAAmB;IACnB,iBAAiB;IACjB,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,aAAa;IACb,qCAAqC,EAAE,uCAAuC;IAC9E,SAAS,EAAE,+CAA+C;IAC1D,uBAAuB;IACvB,mBAAmB;EACrB;;EAEA;IACE,mBAAmB,EAAE,iEAAiE;IACtF,oBAAoB,EAAE,oCAAoC;EAC5D;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,aAAa;IACb,mBAAmB;IACnB,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,YAAY;IACZ,mBAAmB;IACnB,mBAAmB;EACrB;;EAEA;IACE,YAAY;IACZ,YAAY;EACd;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,kBAAkB;IAClB,SAAS;IACT,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,0BAA0B;EAC5B;;EAEA;IACE,cAAc;IACd,mBAAmB;EACrB;;EAEA;IACE,aAAa;IACb,uBAAuB;IACvB,kBAAkB;IAClB,YAAY;EACd","sourcesContent":[".playerGridContainer {\r\n    width: 100%;\r\n    padding: 20px;\r\n    text-align: center;\r\n    color: #fff;\r\n    max-width: 500px;\r\n  }\r\n  \r\n  .playerGridContainer p {\r\n    margin-bottom: 20px;\r\n    font-family: Lato;\r\n    font-size: 16px;\r\n    font-weight: 700;\r\n  }\r\n  \r\n  .playerGrid {\r\n    display: grid;\r\n    grid-template-columns: repeat(2, 1fr); /* Définit 2 colonnes de taille égale */\r\n    gap: 20px; /* Espacement entre les éléments de la grille */\r\n    justify-content: center;\r\n    align-items: center;\r\n  }\r\n  \r\n  .playerGrid > *:nth-child(2n + 1):last-child {\r\n    grid-column: span 2; /* Fait en sorte que le dernier élément s'étende sur 2 colonnes */\r\n    justify-self: center; /* Centre l'élément dans la grille */\r\n  }\r\n  \r\n  .playerCard {\r\n    display: flex;\r\n    flex-direction: column;\r\n    align-items: center;\r\n    justify-content: center;\r\n    height: 160px;\r\n    border-radius: 10px;\r\n    padding: 8px;\r\n    cursor: pointer;\r\n  }\r\n  \r\n  .playerCard img {\r\n    height: 80px;\r\n    object-fit: contain;\r\n    margin-bottom: 10px;\r\n  }\r\n\r\n  .playerCard svg{\r\n    margin: 15px;\r\n    height: 50px;\r\n  }\r\n  \r\n  .playerCard .playerName {\r\n    font-size: 16px;\r\n    font-weight: 700;\r\n    margin-bottom: 5px;\r\n    margin-top: 8px;\r\n  }\r\n  \r\n  .playerCard .playerNumber {\r\n    position: absolute;\r\n    top: 32px;\r\n    font-size: 24px;\r\n    font-weight: 700;\r\n    color: #C3D32C;\r\n    text-shadow: 1px 1px black;\r\n  }\r\n  \r\n  .addIcon {\r\n    color: #C3D32C;\r\n    margin-bottom: 10px;\r\n  }\r\n  \r\n  .shirtNumber{\r\n    display: flex;\r\n    justify-content: center;\r\n    position: relative;\r\n    height: 80px;\r\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
